import { render, staticRenderFns } from "./default-list.vue?vue&type=template&id=03315dff"
import script from "./default-list.vue?vue&type=script&lang=js"
export * from "./default-list.vue?vue&type=script&lang=js"
import style0 from "./default-list.vue?vue&type=style&index=0&id=03315dff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports